"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    readOnly: {
        fontWeight: 400,
        fontSize: 14,
        '& h1': {
            fontSize: 18,
            fontWeight: 700,
            color: theme.grey1
        },
        '& strong': {
            fontWeight: 700,
            color: theme.grey1
        },
        '& li': {
            position: 'relative',
            paddingLeft: 22,
            '&::before': {
                position: 'absolute',
                content: '"•"',
                color: theme.indigo3,
                fontWeight: 'bold',
                width: '1em',
                marginLeft: '-1em'
            }
        }
    },
    title: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.grey3,
        marginBottom: 3
    }
});
//# sourceMappingURL=draftReaderWidget.style.js.map